const twClasses = {
    flexCenterAll: 'flex justify-center items-center',
    dataActiveClasses: [
        'flex',
        'relative',
        'h-full',
        'border-2',
        'border-transparent',
        'hover:bg-neutral-200 ',
        'data-[active=true]:text-gray-900',
        'data-[active=true]:border-neutral-200',
        // 'px-2',
        // 'py-0',
        // 'h-12',
    ].join(' '),
    inputError: 'border-2 border-red-500 [.border-2_&]:border-0.',
    pageHeightSetter: 'flex flex-col w-full',
};

export default twClasses;
